import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import Switch, { SwitchProps } from "@mui/material/Switch";
import React from "react";
import { COLORS } from "../../assets/theme";

export interface CustomSwitchProps extends SwitchProps {
  label?: string;
  fontWeight?: number | string;
  fontSize?: string | number;
  activeText?: string;
  inactiveText?: string;
  highlightLabelStar?: boolean;
}

const StyledSwitch = styled(Switch)<{
  activeText: string;
  inactiveText: string;
  checked?: boolean;
}>(({ activeText, inactiveText, checked }) => ({
  width: 80,
  height: 36,
  padding: 0,
  display: "flex",
  position: "relative",
  "--active-text": `"${activeText}"`,
  "--inactive-text": `"${inactiveText}"`,
  "& .MuiSwitch-switchBase": {
    padding: 4,
    "&.Mui-checked": {
      transform: "translateX(40px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: COLORS.GOLD,
        opacity: 1,
      },
    },
  },
  "& .MuiSwitch-thumb": {
    width: 28,
    height: 28,
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
  },
  "& .MuiSwitch-track": {
    borderRadius: 18,
    backgroundColor: "#bdbdbd",
    opacity: 1,
    position: "relative",
    "&::before": {
      content: checked ? "var(--active-text)" : '""',
      position: "absolute",
      left: 8,
      top: "50%",
      transform: "translateY(-50%)",
      fontSize: "0.65rem",
      fontWeight: "400",
      lineHeight: "1rem",
      color: "#fff",
    },
    "&::after": {
      content: !checked ? "var(--inactive-text)" : '""',
      position: "absolute",
      right: 8,
      top: "50%",
      transform: "translateY(-50%)",
      fontSize: "0.65rem",
      fontWeight: "400",
      lineHeight: "1rem",
      color: "#fff",
    },
  },
}));

const CustomSwitch: React.FC<CustomSwitchProps> = ({
  label,
  fontWeight = "normal",
  fontSize = "1rem",
  activeText = "Active",
  inactiveText = "Inactive",
  checked = false,
  hidden = false,
  disabled = false,
  highlightLabelStar = false,
  ...props
}) => {
  return (
    <Box
      display={hidden ? "none" : "flex"}
      alignItems="center"
      justifyContent="space-between"
      sx={{
        width: "100%",
        pointerEvents: disabled ? "none" : "auto", 
        opacity: disabled ? 0.5 : 1, 
      }}
    >
      {label && (
        <Typography
          sx={{
            color: COLORS.typographyColor,
            fontWeight: fontWeight,
            fontSize: fontSize,
            marginLeft: "5px",
            marginRight: "5px",
            flexGrow: 1,
          }}
        >
          {label}{" "}
          {highlightLabelStar && <span style={{ color: "red" }}>*</span>}
        </Typography>
      )}
      <StyledSwitch
        disabled={disabled}
        checked={checked}
        activeText={activeText}
        inactiveText={inactiveText}
        {...props}
      />
    </Box>
  );
};

export default CustomSwitch;
